<template>
	<header>
		<div
			class="topnav top"
			:class="
				showTopNav || $store.getters.layout == 'Mobile' ? '' : 'showborder'
			"
		>
			<div class="topnav__left">
				<button
					class="topnav__menu"
					@click="showOverlayMenu = !showOverlayMenu"
				>
					<div class="hambager">
						<div class="hambager__bar" :class="{ topopen: showOverlayMenu }" />
						<div
							class="hambager__bar short"
							:class="{ midopen: showOverlayMenu }"
						/>
						<div class="hambager__bar" :class="{ botopen: showOverlayMenu }" />
					</div>
				</button>
				<logo @click.native="goTo('/', 'home')" />
				<!-- <locale-switcher></locale-switcher> -->
			</div>
			<div class="topnav__right">
				<balance-widget class="visible-desktop" v-if="!env.disabledFeatures.includes('balanceWidget') && authenticated"/>
				<div
					v-if="$auth.getAuthStatus()"
					class="topnav__session__links visible-desktop"
				>
					<notifications-icon />
					<router-link
						class="topnav__session__links__item"
						to="/mybets"
						active-class="active"
						exact
						replace
					>
						<svg
							class="topnav__session__links__item__icon"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect
								x="4"
								y="4"
								width="15.5"
								height="16"
								rx="5"
								stroke-width="1.5"
								stroke-linejoin="round"
							/>
							<path
								d="M8.44434 8.88892H11.5816"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
							<path
								d="M8.44434 12H15.111"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
							<path
								d="M8.44434 15.1111H15.111"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
						</svg>

						<span class="nav__item__label">{{ $t("nav.my-bets") }}</span>
					</router-link>
					<router-link
						class="topnav__session__links__item"
						to="/profile"
						active-class="active"
						exact
						replace
					>
						<svg
							class="topnav__session__links__item__icon"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								cx="12"
								cy="7"
								r="3"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
							<path
								d="M18 17C18 19.7614 14.7614 20 12 20C9.23858 20 6 19.7614 6 17C6 14.2386 9.23858 12 12 12C14.7614 12 18 14.2386 18 17Z"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
						</svg>

						<span class="nav__item__label">{{ $t("nav.profile") }}</span>
					</router-link>
				</div>
					<top-session-button />
					<top-session-balance-info
					v-if="env.displayTopSessionBalanceInfo && $auth.getAuthStatus()" class="visible-mobile"/>
				<div class="visible-desktop" style="padding: 0 15px">
					<toggle-button />
				</div>
				<search-icon class="visible-mobile" />
				<notifications-icon
					v-show="$auth.getAuthStatus()"
					class="visible-mobile"
				/>
			</div>
		</div>

		<!--		Notification banner - displays if message is in session variable notification-banner-message-->
		<div v-if="hasMessage && isAuthenticated">
			<notification-banner
				:name="'footer-notification-banner'"
				:dismissable="true"
				:advanced="message.advanced"
				:confirm-dismiss-forever="message.confirmDismissForever"
				:image="
					message.image
						? message.image
						: env.mobileUrl + '/static/images/icon-120x120.png'
				"
				:title="message.title"
				:message="message.msg"
				:action-label="message.actionLabel"
				:action-url="message.actionUrl"
				@click="(url) => bannerNotificationAction(url)"
			/>
		</div>
		<div
			v-show="showTopNav && $store.getters.layout == 'Desktop'"
			class="nav__container"
		>
			<div class="nav">
				<router-link
					class="nav--item"
					:class="{
						'nav--item': 1,
						selected:
							[
								'home',
								'prebet-markets',
								'sport-countries',
								'sport-leagues',
								'sport',
								'sport-competition',
							].indexOf($route.name) > -1,
					}"
					:to="{ name: 'home' }"
				>
					{{ $t("nav.home") }}
				</router-link>

				<router-link
					v-if="env.setDefaultLiveRoute && getSoccerCount"
					v-show="$store.getters.layout == 'Desktop'"
					:class="{
						'nav--item': 1,
						selected: ['live', 'live-markets'].indexOf($route.name) > -1,
					}"
					to="/live/soccer"
				>
					{{ $t("nav.live") }} ({{ $store.getters.numberOfLiveMatches }})
				</router-link>

				<router-link
					v-if="!env.setDefaultLiveRoute || ( env.setDefaultLiveRoute && !getSoccerCount) "
					v-show="$store.getters.layout == 'Desktop'"
					:class="{
						'nav--item': 1,
						selected: ['live', 'live-markets'].indexOf($route.name) > -1,
					}"
					to="/live"
				>
					{{ $t("nav.live") }} ({{ $store.getters.numberOfLiveMatches }})
				</router-link>

				<router-link
					v-if="productAvailable('jackpots')"
					:class="{
						'nav--item': 1,
						selected:
							[
								'jackpots',
								'grand-jackpot',
								'midweek-jackpot',
								'jackpot-results',
								'jackpot-result',
								'boosted-multibet-events',
							].indexOf($route.name) > -1,
					}"
					:to="{ name: activeJackPot.routeName }"
				>
					{{ $t("nav.jackpots") }}
				</router-link>

				<router-link
					v-if="productAvailable('shikisha')"
					class="nav--item"
					:to="`/${env.shikishaProductName.replace(/\s/, '-').toLowerCase()}`"
					:class="{
						selected:
							$route.path ==
							`/${env.shikishaProductName.replace(/\s/, '-').toLowerCase()}`,
					}"
				>
					{{ env.shikishaProductName }}
					{{
						numberOfBetBuilderMatches > 0
							? `(${numberOfBetBuilderMatches})`
							: ""
					}}
				</router-link>
				<router-link
					v-if="env.availableProducts.includes('aviator')"
					class="nav--item"
					to="/aviator"
					:class="{
						selected: $route.path == `/aviator`,
					}"
				>
					<span>Aviator</span>
				</router-link>
				<router-link
					v-if="productAvailable('ligiBigi')"
					class="nav--item visible-desktop"
					:to="{ name: 'ligi-bigi' }"
					:class="{
						selected: ['ligi-bigi'].indexOf($route.name) > -1,
					}"
				>
					{{ $t("nav.ligi-bigi") }}
					<new-badge style="right: 0; top: 0" />
				</router-link>
				<router-link
					v-if="productAvailable('betikaLotto')"
					class="nav--item"
					:class="{
						selected: ['betikaLotto'].indexOf($route.name) > -1,
					}"
					:to="{ name: 'betikaLotto' }"
				>
					{{ $t("nav.betika-lotto") }}
					<new-badge style="right: 0; top: 0" />

				</router-link>
				<router-link
					v-if="productAvailable('casino')"
					class="nav--item"
					:to="{ name: 'casino' }"
					:class="{
						selected:
							['casino', 'casino-category', 'casino-game'].indexOf(
								$route.name
							) > -1,
					}"
				>
					{{ $t("nav.casino") }}
					<new-badge v-if="isNewGame('casino')" style="right: 0; top: 0" />
				</router-link>
				
				<router-link
					v-if="productAvailable('offersNRewards')"
					class="nav--item"
					to="/promotions"
				>
					{{ $t("legal.promotions") }}
					{{ recCount !== 0 ? `(${recCount})` : null }}
				</router-link>
				<router-link
					v-if="productAvailable('leaderboard')"
					class="nav--item"
					to="/leaderboard"
				>
					{{ $t("general.leaderboard") }}
				</router-link>
				<router-link
					v-if="productAvailable('goldenRace')"
					class="nav--item visible-desktop"
					:to="{ name: 'betika-super-league' }"
					:class="{
						selected: ['betika-super-league'].indexOf($route.name) > -1,
					}"
				>
					{{ $t("nav.super-league") }}
				</router-link>

				<router-link
					v-if="
						productAvailable('virtuals') && $store.getters.layout == 'Desktop'
					"
					class="nav--item"
					:to="{ name: 'virtual' }"
					:class="{
						selected:
							[
								'virtual',
								'virtuals',
								'virtuals-markets',
								'virtuals-ongoing',
								'virtuals-results',
								'virtuals-table',
								'virtuals-matches',
							].indexOf($route.name) > -1,
					}"
				>
					{{ $t("nav.virtuals") }}
				</router-link>

				<router-link
					v-if="
						productAvailable('virtualHub') && $store.getters.layout == 'Desktop'
					"
					class="nav--item"
					:to="{ name: 'virtuals' }"
					:class="{
						selected:
							[
								'virtual-game',
								'virtuals',
								'golden-race-virtual-game',
								'virtuals-markets',
								'virtuals-ongoing',
								'virtuals-results',
								'virtuals-table',
								'virtuals-matches',
							].indexOf($route.name) > -1,
					}"
				>
					{{ $t("nav.virtuals") }}
					<new-badge style="right: 0; top: 0" />
				</router-link>

				<!-- Comet Crash -->
				<router-link
					v-if="productAvailable('comet')"
					class="nav--item"
					:to="{ name: 'comet-crash' }"
					:class="{
						selected: ['comet-crash'].indexOf($route.name) > -1,
					}"
				>
					Comet Crash
				</router-link>
				<router-link
					v-if="productAvailable('splitPot')"
					class="nav--item"
					:to="`/${env.splitPotName.replace(/\s/, '-').toLowerCase()}`"
					:class="{
						selected:
							$route.path ==
							`/${env.splitPotName.replace(/\s/, '-').toLowerCase()}`,
					}"
				>
					{{ env.splitPotName }}
					<new-badge style="right: 0; top: 0" />
				</router-link>

				<!-- // CRASH -->
				<router-link
					v-if="env.availableProducts.includes('crashGames')"
					class="nav--item"
					to="/crash-games"
					:class="{
						selected: $route.path === `/crash-games`,
					}"
				>
					Crash Games
					<new-badge style="right: 0; top: 0" />
				</router-link>

				<router-link
					v-if="productAvailable('livescore')"
					class="nav--item"
					:class="{
						selected: ['livescore'].indexOf($route.name) > -1,
					}"
					:to="{ name: 'livescore' }"
				>
					{{ $t("nav.live-score") }}
				</router-link>

				<a
					v-if="productAvailable('appLink')"
					class="nav--item"
					@click="goToApp"
				>
					<a
						:ref="'appLink'"
						:href="env.appLink"
						target="_blank"
						class="hide"
						>{{ $t("nav.download-app") }}</a
					>
					App
				</a>

			</div>
			<a
				v-if="env.helpLink && !isKenya"
				class="top-nav-link visible-desktop"
				:href="env.helpLink"
				target="_blank"
			>
				<svg
					width="17"
					height="16"
					viewBox="0 0 17 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="top-nav-link__icon"
				>
					<path
						d="M8.5 0.25C9.875 0.25 11.1875 0.625 12.375 1.3125C13.5625 2 14.5 2.9375 15.1875 4.125C15.875 5.3125 16.25 6.625 16.25 8C16.25 9.40625 15.875 10.6875 15.1875 11.875C14.5 13.0625 13.5625 14.0312 12.375 14.7188C11.1875 15.4062 9.875 15.75 8.5 15.75C7.09375 15.75 5.8125 15.4062 4.625 14.7188C3.4375 14.0312 2.46875 13.0625 1.78125 11.875C1.09375 10.6875 0.75 9.40625 0.75 8C0.75 6.625 1.09375 5.3125 1.78125 4.125C2.46875 2.9375 3.4375 2 4.625 1.3125C5.8125 0.625 7.09375 0.25 8.5 0.25ZM8.5 14.25C9.625 14.25 10.6562 13.9688 11.625 13.4062C12.5625 12.8438 13.3438 12.0938 13.9062 11.125C14.4688 10.1875 14.75 9.125 14.75 8C14.75 6.875 14.4688 5.84375 13.9062 4.875C13.3438 3.9375 12.5625 3.15625 11.625 2.59375C10.6562 2.03125 9.625 1.75 8.5 1.75C7.375 1.75 6.3125 2.03125 5.375 2.59375C4.40625 3.15625 3.65625 3.9375 3.09375 4.875C2.53125 5.84375 2.25 6.875 2.25 8C2.25 9.125 2.53125 10.1875 3.09375 11.125C3.65625 12.0938 4.40625 12.8438 5.375 13.4062C6.3125 13.9688 7.375 14.25 8.5 14.25ZM11.8438 6.28125C11.8438 5.78125 11.6875 5.3125 11.375 4.875C11.0625 4.46875 10.6875 4.125 10.1875 3.875C9.6875 3.625 9.1875 3.5 8.6875 3.5C7.96875 3.5 7.375 3.65625 6.875 3.9375C6.375 4.21875 5.90625 4.625 5.53125 5.1875C5.46875 5.28125 5.46875 5.375 5.46875 5.46875C5.46875 5.59375 5.53125 5.65625 5.625 5.71875L6.5 6.375C6.5625 6.4375 6.65625 6.46875 6.75 6.4375C6.84375 6.4375 6.9375 6.375 7 6.3125C7.25 5.96875 7.5 5.71875 7.6875 5.59375C7.90625 5.46875 8.1875 5.375 8.5 5.375C8.8125 5.375 9.125 5.46875 9.375 5.625C9.625 5.8125 9.78125 6 9.78125 6.25C9.78125 6.4375 9.6875 6.625 9.5625 6.75C9.4375 6.875 9.21875 7 8.90625 7.1875L8.84375 7.21875C8.40625 7.46875 8.09375 7.6875 7.90625 7.875C7.5625 8.21875 7.40625 8.625 7.40625 9.09375V9.375C7.40625 9.5 7.4375 9.59375 7.5 9.65625C7.5625 9.71875 7.65625 9.75 7.78125 9.75H9.21875C9.3125 9.75 9.40625 9.71875 9.46875 9.65625C9.53125 9.59375 9.59375 9.5 9.59375 9.375V9.1875C9.59375 9.0625 9.65625 8.9375 9.8125 8.8125C9.875 8.75 10.0625 8.625 10.3125 8.46875C10.7812 8.21875 11.125 7.96875 11.3438 7.71875C11.6562 7.34375 11.8438 6.84375 11.8438 6.28125ZM9.8125 11.5C9.8125 11.1562 9.65625 10.8438 9.40625 10.5938C9.15625 10.3438 8.84375 10.1875 8.5 10.1875C8.125 10.1875 7.8125 10.3438 7.5625 10.5938C7.3125 10.8438 7.1875 11.1562 7.1875 11.5C7.1875 11.875 7.3125 12.1875 7.5625 12.4375C7.8125 12.6875 8.125 12.8125 8.5 12.8125C8.84375 12.8125 9.15625 12.6875 9.40625 12.4375C9.65625 12.1875 9.8125 11.875 9.8125 11.5Z"
					/>
				</svg>

				<span class="top-nav-link__text">{{ $t("nav.help-support") }}</span>
			</a>
			<download-fixtures-link />
			<search-icon class="visible-desktop" />
		</div>
		<portal to="fullscreen">
			<overlay-menu
				:show-overlay-menu="showOverlayMenu"
				@close="showOverlayMenu = false"
			/>
		</portal>
		<!-- <portal to="fullscreen"> -->
		<!-- <geo-banner
			@close-banner="showGeoBanner = false"
			:message="geoBannerMessage"
			:selectedCountryCode="selectedCountryCode"
			v-if="showGeoBanner"
		>
			<button
				@click="confirmCountry"
				class="geo-country__button"
				slot="default"
				v-if="showSameCountryButton"
			>
				Visit Betika {{ selectedCountryName }}
			</button>
		</geo-banner> -->
		<!-- </portal> -->
	</header>
</template>

<script>
import NotificationBanner from "../../components/Shared/NotificationBanner.vue";
import DownloadFixturesLink from "../DownloadFixtures/Link.vue";
import NotificationsIcon from "../Notifications/Icon.vue";
import SearchIcon from "../Search/Icon.vue";
import NewBadge from "../Shared/NewBadge.vue";
import GeoBanner from "./GeoCountryBanner.vue";
import LanguageSelector from "./LanguageSelector.vue";
import LocaleSwitcher from "./LocaleSwitcher.vue";
import OverlayMenu from "./OverlayMenu.vue";
import ToggleButton from "./ThemeToggleButton.vue";
import TopSessionBalanceInfo from "./TopSessionBalanceInfo.vue";
import TopSessionButton from "./TopSessionButton.vue";
import BalanceWidget from "./Widgets/BalanceWidget.vue";

export default {
	name: "Top",
	components: {
		BalanceWidget,
		NotificationsIcon,
		TopSessionButton,
		TopSessionBalanceInfo,
		OverlayMenu,
		SearchIcon,
		DownloadFixturesLink,
		LanguageSelector,
		ToggleButton,
		LocaleSwitcher,
		NewBadge,
		NotificationBanner,
		GeoBanner,
	},
	props: {
		showTopNav: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			option: "",
			balanceSet: false,
			numberOfLiveMatches: 0,
			numberOfBetBuilderMatches: 0,
			loggedIn: false,
			showOverlayMenu: false,
			showGeoBanner: false,
			hasMessage: false,
			message: null,
			geoBannerMessage: null,
			selectedCountryCode: null,
			selectedCountryName: null,
			chosenCountry: "",
			defaultCountryCode: "",
			showSameCountryButton: false,
		};
	},
	computed: {
		authenticated() {
			return this.$store.getters.authenticated;
		},
		betSlipCount() {
			return (
				this.$store.getters.betSlipCount +
				this.$store.getters.jengabetBetSlipCount +
				this.$store.getters.virtualBetslipCount
			);
		},
		isKenya() {
			return this.env.country === 'KENYA';
		},
		isAuthenticated() {
			return this.$auth.getAuthStatus();
		},
		recCount() {
			let vm = this;
			const getRecs = vm.$store.getters["promos/list"];

			let countDynamic = 0;
			if (getRecs.length !== 0) {
				countDynamic = getRecs[0].promoData.length;
			}
			let countStatic = 0;
			if (this.env.staticPromos.length !== 0) {
				countStatic = this.env.staticPromos.filter((l) => l.isEnabled).length;
			}

			return countDynamic + countStatic;
		},
		activeJackPot() {
			return this.env.jackpots.find(
				(jackpot) => jackpot.id === this.env.defaultJackpotId
			);
		},
		getSoccerCount() {
		let vm = this;
		let liveData = {};
		let soccer = {};
		let soccerLive = 0;
		if(this.$store.getters.liveSports.data){
			liveData = vm.$store.getters.liveSports.data;
			soccer = liveData.find(sport => sport.sport_name === "Soccer");
			soccerLive = soccer ? { sport_name: soccer.sport_name, count: soccer.count } : 0;
		}
		return soccerLive.count > 0 ? true : false;
		},
	},

	watch: {
		$route: function() {
			this.loggedIn = JSON.parse(window.localStorage.getItem("authenticated"));
		},
	},
	mounted(){
		this.$root.$emit("refresh-live-sports-list");
	},
	beforeMount() {
		let vm = this;
		vm.loggedIn = JSON.parse(window.localStorage.getItem("authenticated"));
		vm.defaultCountryCode =
			process.env.DEPLOY_ENV == "web" || process.env.DEPLOY_ENV == "mobile_app"
				? process.env.COUNTRY_CODE
				: localStorage.getItem("countryCode");
		vm.getTotals();
		vm.checkUserBrowseCountry();
		setInterval(() => {
			if (vm.$store.getters["settings/settings"].autorefresh.status)
				vm.getTotals();
		}, 10000);

		vm.hasMessage = localStorage.hasOwnProperty("notification-banner-message");
		if (localStorage.hasOwnProperty("notification-banner-message") === true) {
			vm.message = JSON.parse(
				localStorage.getItem("notification-banner-message")
			);
		}
	},
	methods: {
		confirmCountry() {
			let vm = this;
			vm.chosenCountry = vm.env.availableCountries.find((country) => {
				return country.code == vm.selectedCountryCode;
			});
			localStorage.clear();
			localStorage.countryCode = JSON.stringify(vm.selectedCountryCode);
			vm.showGeoBanner = false;
			vm.$cookie.set("btk-browse-country", vm.selectedCountryCode, 365);
			let localeToSave = vm.chosenCountry.defaultPath.split("/")[1];
			vm.$cookie.set("btk-lang-cn", localeToSave, 10 * 365);
			window.location.href = `${vm.env.desktopUrl}${vm.chosenCountry.defaultPath}`;
		},
		checkUserBrowseCountry() {
			let vm = this;
			if (process.env.DEPLOY_ENV == "mobile_app") return;
			let supportedCountries = vm.env.availableCountries.map((country) => {
				return country.code;
			});
			let browseCountry = vm.$cookie.get("btk-browse-country");
			vm.$axios.get(`${GEO_IP_URL}`).then((response) => {
				let userAccessCountry = response.data.country;
				let userAccessCountryCode = response.data.countryCode
					? response.data.countryCode.toUpperCase()
					: "";

				if (
					supportedCountries.includes(userAccessCountryCode) &&
					userAccessCountryCode !== vm.defaultCountryCode
				) {
					let foundCountry = vm.env.availableCountries.find((country) => {
						return country.code == userAccessCountryCode;
					});
					vm.showGeoBanner = true;
					vm.selectedCountryCode = userAccessCountryCode;
					vm.selectedCountryName = foundCountry.name;
					vm.showSameCountryButton = true;
					vm.geoBannerMessage = `
            We notice you are visiting us from ${userAccessCountry}.<br/>
            Close this notice to continue or click the button below to use Betika ${userAccessCountry} `;
				} else if (
					!supportedCountries.includes(userAccessCountryCode) &&
					browseCountry !== vm.defaultCountryCode
				) {
					vm.showGeoBanner = true;
					vm.selectedCountryCode = process.env.COUNTRY_CODE;
					vm.showSameCountryButton = false;
					vm.geoBannerMessage = `
              We currently do not have operations in ${userAccessCountry}.<br/>
              Close this notice to continue or choose a different country below `;
				}
			});
		},
		getTotals() {
			let vm = this;
			this.$axios
				.get(`${BASE_URL}uo/totalMatches`)
				.then((response) => {
					if (response.data) {
						this.numberOfLiveMatches = response.data.total_live_matches;
						this.numberOfBetBuilderMatches =
							response.data.total_shikisha_matches;
						vm.$store.commit(
							"setNumberOfLiveMatches",
							response.data.total_live_matches
						);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		goToApp() {
			this.$refs.appLink.click();
		},

		goTo(location, option, isDataHeavy = false) {
			let vm = this;
			location = `/${location.replace(/^\/|\/$/g, "")}`;
			if (isDataHeavy) {
				vm.$store.commit("dataNotifier/setNext", {
					nextType: "cb",
					nextCb: () => {
						vm.option = option;
						vm.$router.push(location);
					},
				});
				vm.$store.commit("dataNotifier/toggleShow");
			} else {
				vm.option = option;
				vm.$router.replace(location);
			}
		},

		// Rerirects user to url specified in the notification banner's actionUrl value
		bannerNotificationAction(url) {
			let vm = this;
			if (url.length > 0) {
				vm.$router.push(url);
			}
			if (localStorage.hasOwnProperty("notification-banner-message") === true) {
				localStorage.removeItem("notification-banner-message");
			}
		},
		isNewGame(sportName) {
			const game = this.env.hardCodedSports.find(
				({ sport_name }) => sport_name === sportName
			);

			return game &&  game.new_badge
		},
	},
};
</script>

<style lang="scss">
.position-top-toggle {
	margin-top: 5px;
	margin-right: 21px;
}
header {
	display: flex;
	flex-direction: column;
	position: fixed;
	top: 0;
	width: 100%;
	background: var(--light-gray);
	max-width: var(--app-width);
	min-width: 320px;
	z-index: 99999;

	.topnav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		color: var(--black);
		font-size: var(--font-medium);
		background: var(--white);
		padding: 10px;
		padding-bottom: 5px;

		&__left {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		&__menu {
			background: none;
			border: none;
			padding: 0 10px 0 0;
			line-height: 0;

			svg {
				fill: var(--light-black);
				padding-left: 0px;
				height: 25px;
			}
		}
		&__logo {
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		&__right {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		&__session {
			&__links {
				display: flex;
				flex-direction: row;
				&__item {
					padding: 5px;
					text-align: center;
					cursor: pointer;
					font-size: var(--font-medium);
					font-weight: var(--font-weight-lighter);
					display: flex;
					flex-direction: row;
					align-items: center;
					text-decoration: none;
					color: var(--black);
					white-space: nowrap;
					margin-right: 10px;
					&__icon {
						height: 20px;
						stroke: var(--black);
						margin-right: 5px;
					}
					&.active {
						color: var(--green);
						font-weight: var(--font-weight-medium);

						.topnav__session__links__item__icon > path,
						circle,
						rect {
							stroke: var(--green);
							stroke-width: 1.8px;
						}
					}
				}
			}
		}
		&__balance {
			&__widget {
				border-right: 1px solid var(--line-11);
				@media (max-width: 440px) {
					display: none;
				}
				@media (max-width: 1023px) {
					border-right: 0;
				}
				font-size: var(--font-medium);
				font-weight: var(--font-weight-bold);
				svg {
					cursor: pointer;
					padding-left: 10px;
					path {
						stroke: var(--black);
					}
				}
				&__inner {
					display: flex;
					align-items: center;
					color: var(--green);
					padding-right: 10px;
					line-height: normal;
					&--asterix {
						vertical-align: middle;
					}
				}
			}
		}
	}

	.nav {
		display: flex;
		flex-direction: row;
		overflow: auto;
		overflow-y: hidden; // hide vertical
		transition: display 800ms ease;
		width: 100%;
		margin: 0 10px;

		&::-webkit-scrollbar {
			display: none;
		}
		&__container {
			display: flex;
			justify-content: space-between;
			background: var(--white);
		}

		&--item {
			display: block;
			border: none;
			display: flex;
			position: relative;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			padding: 10px 15px;
			font-size: var(--font-medium);
			white-space: nowrap;
			color: var(--light-black);
			border-bottom: none;
			text-decoration: none;
			font-weight: var(--font-weight-lighter);
			@media (min-width: 1023px) {
				padding: 10px;
				font-size: var(--font-normal);
				cursor: pointer;
			}
			&.selected {
				border-bottom-color: var(--green);
				color: var(--green);
				font-weight: var(--font-weight-bold);
				&:after {
					content: "";
					position: absolute;
					display: block;
					width: 100%;
					height: 4px;
					left: 50%;
					transform: translate(-50%, 0%);
					border-radius: 4px 4px 0px 0px;
					background: var(--green);
					bottom: 0;
				}
			}
		}
	}
}
</style>
